import { useState, useEffect } from 'react';

export function useDarkMode() {
  const [dark, setDark] = useState(() => {
    const stored = localStorage.getItem('dark-mode');
    if (stored !== null) return stored === 'true';
    return false;
  });

  useEffect(() => {
    localStorage.setItem('dark-mode', String(dark));
    document.documentElement.style.backgroundColor = dark ? '#0a0a0a' : '#ffffff';
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', dark ? '#0a0a0a' : '#ffffff');
  }, [dark]);

  return [dark, setDark] as const;
}
